/** 首页公司简介（纯文案，便于与接口数据分离维护） */
export const companyIntroParagraphs = [
  "我们是一家专注于跨境电商与跨境仓储领域的技术服务公司，致力于通过系统化、智能化的解决方案，帮助企业提升运营效率、降低成本、实现数据驱动增长。",
  "通过自主研发的多套核心系统，我们打通订单、库存、物流、分销与数据分析全链路，助力企业实现业务数字化升级。"
];

/** 适用客户（首页展示） */
export const audienceItems = ["跨境电商卖家", "跨境仓储服务商", "海外仓企业", "分销与渠道商"];
